<div *ngIf="currentTourStep && selectedElementRect && isOrbShowing" (mouseenter)="handleOrb()"
    class="tour-orb tour-{{ currentTourStep.orientation }}" [style.top.px]="orbTopPosition"
    [style.left.px]="orbLeftPosition" [style.transform]="orbTransform">
    <div class="tour-orb-ring"></div>
</div>

<div *ngIf="currentTourStep && !isOrbShowing">
    <div class="guided-tour-user-input-mask" (click)="backdropClick($event)"></div>
    <div class="guided-tour-spotlight-overlay onboarding-type-{{ onboardingType }}" [style.top.px]="overlayTop"
        [style.left.px]="overlayLeft" [style.height.px]="overlayHeight" [style.width.px]="overlayWidth"
        (click)="onClickElementSelected($event)">
    </div>
</div>

<div *ngIf="currentTourStep && !isOrbShowing">
    <div #tourStep *ngIf="currentTourStep"
        class="tour-step tour-{{ currentTourStep.orientation }} tour-{{ typeGuide }} onboarding-type-{{ onboardingType }}"
        [ngClass]="{
                    'page-tour-step': !currentTourStep.selector
                }" [style.top.px]="(currentTourStep.selector && selectedElementRect ? topPosition : null)"
        [style.left.px]="(currentTourStep.selector && selectedElementRect ? leftPosition : null)"
        [style.width.px]="(currentTourStep.selector && selectedElementRect ? calculatedTourStepWidth : null)"
        [style.transform]="(currentTourStep.selector && selectedElementRect ? transform : null)">
        <ng-container *ngIf="currentTourStep.selector">
            <div style="--var-left-arrow: {{ currentTourStep.customStyleLeftArrow }}px" class="tour-arrow"></div>
        </ng-container>
        <div class="tour-block" (swipeleft)="guidedTourService.nextStep()" (swiperight)="guidedTourService.backStep()">
            <div *ngIf="
                        progressIndicatorLocation === progressIndicatorLocations.TopOfTourBlock
                        && !guidedTourService.onResizeMessage" class="tour-progress-indicator">
                <ng-container *ngTemplateOutlet="progress"></ng-container>
            </div>
            <button class="btn btn-close" (click)="guidedTourService.skipTour('CLOSE')">
                <i class="icon-edponline-Bop-071 color-brownish-grey" aria-hidden="true"></i>
            </button>

            <ng-container *ngIf="!!currentTourStep.image">
                <div class="container-image"></div>
                <img [src]="prefixPathImage + currentTourStep.image" alt="image step">
            </ng-container>

            <ng-container *ngIf="typeGuide === 'intro'">
                <ngx-guided-tour-steps-bullet [total]="guidedTourService.currentTourStepCount"
                    [actived]="guidedTourService.currentTourStepDisplay"></ngx-guided-tour-steps-bullet>
            </ng-container>

            <h3 class="tour-title" *ngIf="currentTourStep.title && currentTourStep.selector">
                {{ currentTourStep.title }}
            </h3>
            <h2 class="tour-title" *ngIf="currentTourStep.title && !currentTourStep.selector">
                {{ currentTourStep.title }}
            </h2>

            <div class="tour-content">
                <p [innerHTML]="currentTourStep.content"></p>
            </div>
            <ng-container *ngIf="onboardingType !== 'tooltip'">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </ng-container>
        </div>

    </div>
</div>

<ng-template #progress>
    <ng-container *ngTemplateOutlet="
                progressIndicator || defaultProgressIndicator; 
                context: { currentStepNumber: guidedTourService.currentTourStepDisplay, totalSteps: guidedTourService.currentTourStepCount }
            ">
    </ng-container>
</ng-template>

<ng-template #defaultProgressIndicator let-currentStepNumber="currentStepNumber" let-totalSteps="totalSteps">
    <ng-container
        *ngIf="progressIndicatorLocation === progressIndicatorLocations.InsideNextButton">&nbsp;</ng-container>
    {{currentStepNumber }}/{{ totalSteps }}
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="typeGuide !== 'intro'; else simpleButton">
        <div class="tour-buttons">
            <div class="skip-button">
                <ngx-guided-tour-steps-bullet [total]="guidedTourService.currentTourStepCount"
                    [actived]="guidedTourService.currentTourStepDisplay"></ngx-guided-tour-steps-bullet>
            </div>
            <button class="next-button edp-text-seaweed-green" (click)="guidedTourService.nextStep()">
                {{
                guidedTourService.onLastStep ? ("pt.edp.edponline.onboarding.tour.finish" | translate) :
                ("pt.edp.edponline.onboarding.tour.next" | translate)
                }}
                <ng-container *ngIf="!guidedTourService.onLastStep">
                    <i aria-hidden="true" class="icon-edponline-Bop-073 rotate-270 font-weight-bold"></i>
                </ng-container>
            </button>
        </div>
    </ng-container>

    <ng-template #simpleButton>
        <div class="d-flex justify-content-center">
            <button class="btn btn-primary" (click)="guidedTourService.nextStep()">
                {{
                guidedTourService.onLastStep ? ("pt.edp.edponline.onboarding.tour.finish" | translate) :
                ("pt.edp.edponline.onboarding.tour.next" | translate)
                }}
            </button>
        </div>
    </ng-template>
</ng-template>